.dropdownOption {
	padding: 12px 16px;
	cursor: pointer;
	min-width: 100px;
	width: 100%;
	outline: none;
	text-wrap: nowrap;
}

.dropdownOption:hover,
.dropdownOption:focus-visible {
	background-color: var(--elevation-medium);
	outline: none;
}
